<template>
  <ModalDialog
    ref="dialog"
    title="Optimiser Sheet Preview"
    icon="fa-th-large"
    sizeClass="modal-xxl"
    :scrollable="false"
    :showSubmit="false"
  >
    <div>
      <Spinner v-if="loading" />
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>

      <div v-if="!loading && optimiserSheetData">
        <div class="row">
          <div class="col-4">
            <ContentTitle>{{sheetTitle}}</ContentTitle>
          </div>
          <div class="col-8">
            <ContentTitle>Allocations</ContentTitle>
          </div>
        </div>


        <div class="row">
          <div class="col-4">
            <div class="optimiser-sheet-preview-container">
              <div v-html="optimiserSheetData.svgDisplayData" class="optimiser-sheet-preview" />
            </div>
          </div>
          <div class="col-8 optimiser-sheet-allocation-list">
            <OptimiserAllocationList :allocationList="allocationList" :linksEnabled="false" />
          </div>
        </div>
      </div>

    </div>
  </ModalDialog>
</template>

<style>
/* Note: Not scoped to allow nested SVG styling */
.optimiser-sheet-preview-container {
  display: relative;
  width: 100%;
  height: 50vh;
  background: #efefef;
  border: 2px solid #212121;
}
.optimiser-sheet-allocation-list {
  height: 50vh;
  overflow-y: auto;
}
.optimiser-sheet-preview {
  display: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 4px;
}
.optimiser-sheet-preview > svg {
  width: 100%;
  height: 100%;
  max-height: 45vh;
  max-width: 80vw;
}
</style>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import OptimiserAllocationList from '@/modules/optimiser/components/optimiserAllocationList'

export default {
  name: 'PreviewSheetDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog,
    OptimiserAllocationList
  },
  props: {
    optimiserSheetId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      optimiserSheetData: null,
    }
  },
  computed: {
    sheetTitle() {
      if(this.loading || !this.optimiserSheetData)
        return 'Sheet'
        
      return `${this.optimiserSheetData.stock.name} - ${this.optimiserSheetData.height}x${this.optimiserSheetData.width}`
    },
    allocationList() {
      if(this.loading || !this.optimiserSheetData)
        return []

      return this.optimiserSheetData.optimiserSheetAllocations || []
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show(params) {
      this.requestData()

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.glassProductionStationService.getOptimiserSheet(this.optimiserSheetId)
      .then(response => {
        this.optimiserSheetData = response.data
        this.loading = false

      })
      .catch(err => {
        this.loadingError = 'Error loading sheet data'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>